import {ProductListPage as NorthAmericaProductListPage} from '@/features/ProductList/ProductListPage'
import {ProductList} from '@/pages/ProductList'
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {NEW_THEME_FEATURE_COUNTRIES} from '@/utils/constants/marketFeatureCountries'
import {useSelector} from 'react-redux'

const ProductListByMarket = () => {
  const countryCode = useSelector(selectCountryCode)

  if (NEW_THEME_FEATURE_COUNTRIES.includes(countryCode)) {
    return <NorthAmericaProductListPage />
  }

  return <ProductList />
}

export default ProductListByMarket
